import DetailPage from './components/DetailPage';

function App({ dataClubId, isHomepage }) {
  return (
    <DetailPage dataClubId={ dataClubId } isHomepage={isHomepage} />
  );
}

export default App;
